import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReportPropertyDetailService } from '../../residential-property/residential-property-detail.service';
import moment from 'moment';
import { SharedService } from 'src/app/common/services/shared.service';

@Component({
  selector: 'app-land-value-details',
  templateUrl: './land-value-details.component.html',
  styleUrls: ['./land-value-details.component.scss']
})
export class LandValueDetailsComponent {
  @Output() isEmpatyCheck: any = new EventEmitter();
  @Input() propertyInfo: any;

  landValueInfo: any = null;
  CurrencyCode = null;

  constructor(private reportPropertyDetailService: ReportPropertyDetailService,
    private sharedService : SharedService
  ){}

  ngOnChanges(): void {
    this.CurrencyCode = this.reportPropertyDetailService.CurrencyCode;
    this.sharedService.language$.subscribe({
      next : (res: any) => {
        this.getLandValueInfo();
      },
      error : (err:any) => { }
    })
  }

  getLandValueInfo() {
    this.reportPropertyDetailService.getPropertyDetailsLandValue().subscribe(
      {
        next: (res: any) => {
          if (res.status === 200) {
            this.landValueInfo = res.data[0];
            this.isEmpatyCheck.emit(this.landValueInfo?.unit_transactions || this.landValueInfo?.property_transactions ? true: false);
            if (this.landValueInfo.land_value_date) this.landValueInfo["land_value_date"] = moment.utc(this.landValueInfo.land_value_date).local().format('DD MMM YYYY')
            if (this.landValueInfo.max_unit_transaction_date) this.landValueInfo["max_unit_transaction_date"] = moment.utc(this.landValueInfo.max_unit_transaction_date).local().format('DD MMM YYYY')
            if (this.landValueInfo.min_unit_transaction_date) this.landValueInfo["min_unit_transaction_date"] = moment.utc(this.landValueInfo.min_unit_transaction_date).local().format('DD MMM YYYY')
            if (this.landValueInfo.max_property_transaction_date) this.landValueInfo["max_property_transaction_date"] = moment.utc(this.landValueInfo.max_property_transaction_date).local().format('DD MMM YYYY')
            if (this.landValueInfo.min_property_transaction_date) this.landValueInfo["min_property_transaction_date"] = moment.utc(this.landValueInfo.min_property_transaction_date).local().format('DD MMM YYYY')
          } else {
            this.isEmpatyCheck.emit(false);
            this.landValueInfo = null;
          }
        },
        error : (err:any)=>{
            this.isEmpatyCheck.emit(false);
            this.landValueInfo = null;
        }
      }
    )
  }
}
